"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { Suspense } from "react";

type Props = { paramName: string; className: string };

function Filter({ paramName, className }: Props) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const run = searchParams.get(paramName);
  const r3 = run?.substring(0, 1);
  const r2 = run?.substring(1, 2);
  const r1 = run?.substring(2, 3);

  const isRun = (val?: string) => {
    if (run === "rsp" || run === "nsp") return undefined;
    else if (val === "t") return true;
    else if (val === "f") return false;
    else return undefined;
  };
  const toggleRun = (val?: string) => {
    if (val === undefined || val === "a" || val === "f") return "t";
    else if (val === "t") return "f";
    else return "a";
  };

  const handle = (r: 1 | 2 | 3) => {
    const params = new URLSearchParams(searchParams.toString());
    if (!run || run === "rsp" || run === "nsp") {
      if (r === 1) params.set("run", `aat`);
      else if (r === 2) params.set("run", `ata`);
      else if (r === 3) params.set("run", `taa`);
    } else {
      if (r === 1) params.set("run", `${r3}${r2}${toggleRun(r1)}`);
      else if (r === 2) params.set("run", `${r3}${toggleRun(r2)}${r1}`);
      else if (r === 3) params.set("run", `${toggleRun(r3)}${r2}${r1}`);
    }
    router.replace("?" + params.toString(), { scroll: false });
  };
  const handleClear = (r: 1 | 2 | 3, val?: string) => {
    const params = new URLSearchParams(searchParams.toString());
    if (r === 1) params.set("run", `${r3}${r2}a`);
    else if (r === 2) params.set("run", `${r3}a${r1}`);
    else if (r === 3) params.set("run", `a${r2}${r1}`);
    if (params.get("run") === "aaa") params.delete("run");
    router.replace("?" + params.toString(), { scroll: false });
  };
  const BaseComponent = ({ r, val }: { r: 1 | 2 | 3; val?: string }) => {
    const display = isRun(val);
    const color =
      display === undefined
        ? "bg-secondary hover:bg-white "
        : display
        ? "bg-white hover:bg-slate-500"
        : "bg-black hover:bg-slate-500";

    return (
      <div
        className={`${color} border border-white mask mask-diamond flex justify-center items-center`}
        onClick={() => handle(r)}
      >
        {isRun(val) && "🪖"}
      </div>
    );
  };
  const BaseClearComponent = ({ r, val }: { r: 1 | 2 | 3; val?: string }) => {
    return (
      <div
        className={`${
          val === "t" || val === "f" || "invisible"
        } border border-secondary rounded-md hover:bg-secondary text-center`}
        onClick={() => handleClear(r)}
      >
        Clear
      </div>
    );
  };
  return (
    <div className={`border border-primary rounded-md grid grid-cols-4 ${className}`}>
      <div></div>
      <BaseComponent r={2} val={r2} />
      <BaseClearComponent r={2} val={r2} />
      <div></div>
      <BaseComponent r={3} val={r3} />
      <BaseClearComponent r={3} val={r3} />
      <BaseComponent r={1} val={r1} />
      <BaseClearComponent r={1} val={r1} />
    </div>
  );
}

export default function RunBaseFilter(props: Props) {
  return (
    <Suspense
      fallback={
        <div className={`border border-primary rounded-md grid grid-cols-4 ${props.className}`}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      }
    >
      <Filter {...props} />
    </Suspense>
  );
}
